module.exports = {
  localeName: 'en-US',
  momentFormat: 'MM/DD/YYYY',
  qrCodeUrl: 'https://www.inmoment.com/websurvey/2/begin?gateway=NikeNAQRCode&base32=surveyCode&PrintEreceipt=1',
};
